import React from 'react';
import {appUrl} from './GetData';

class PostView extends React.Component  {

    constructor() {
        super()
        this.state = {
            posts: []
        };
    }

    componentDidMount() {
    const slug = this.props.match.params.slug;  
    
    fetch(`https://barnbeckmedia.com/wp-json/wp/v2/posts?slug=${slug}`)
    .then(data => data.json())
    .then(data => {
    this.setState({
    posts: data})
    })
        }

        

    render(){
        
        
        let listposts = this.state.posts.map((post, index) => {


        return (
        
        <div key={index}>
        <h2>{post.title.rendered}</h2>
                
        <p dangerouslySetInnerHTML={{ __html: post.content.rendered }}/>
        </div>
        
        )


        })   


                
    return (

        <div>

        {listposts[0]}

            </div>
    )}
}
    

export default PostView;